module.exports = __webpack_public_path__ + "static/media/texture_07.85a9a8c5.png";